import pathField from "@/helpers/pathField";

export default {
    SET_PROFILE: (state, payload) => {
        //console.log('PROFILE',payload);
        state.profile = payload;
    },
    SET_LIB: (state, payload) => {
        state.lib = payload;
    },
    SET_FAV: (state, payload) => {
        if(payload.old_cars && payload.old_cars.length){
            payload.old_cars.map(el => {
                el.is_special_price = el.is_special_price>0?parseInt(el.is_special_price):0
                el.is_price_changing = el.is_price_changing>0?parseInt(el.is_price_changing):0
            })
        }
        state.favorites = payload;
    },
    SET_DATA(state, {field, data}) {
        pathField(state, field, data)
    },
    SET_POPUP(state, payload) {
        state.popup = payload
    },
    SET_NOTIFICATIONS(state, payload) {
        state.notifications.new_car = payload.new_car;
        state.notifications.stock_car = payload.stock_car;
        state.notifications.old_car = payload.old_car;
        state.notifications.lib = payload.lib;
    },
    setScrollTo(state, val){
        state.scrollTop = val;
    },
    setShowMenu(state,val){
        if(val){
            document.querySelector("body").classList.add("no-scroll");
        }else {
            document.querySelector("body").classList.remove("no-scroll");
        }
        state.showMenu = val;
    },
    setLastCarPageVisit(state,val){
        state.lastCarPageVisit = val;
    },
    SET_FOOTER_DATA(state,val){
        state.footerData = val;
    },
    setSpecialText(state,val){
        state.specialText = val;
    },
    setSorting(state, val) {
        state.sorting = val
    }
}
